// extracted by mini-css-extract-plugin
export default {"root":"yJBEM","rootLink":"DZU4k","title":"aHMWe","body":"RQVMl","header":"daJsJ","date":"_QWbD","status":"qmvCt","statusSuccess":"z42w0"};